/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { injectIntl } from 'react-intl';

import TextBlock from './Text';
import MoreInfo from '../partials/MoreInfo';

import styles from '../../../styles/blocks/text.scss';

const propTypes = {
    intl: PropTypes.shape({
        locale: PropTypes.string,
    }).isRequired,
};

const defaultProps = {

};

const SectionTextBlock = ({
    intl, ...props
}) => {
    const { locale } = intl;
    const moreInfoLink = get(props, `moreInfoLink.${locale}`, get(props, 'moreInfoLink', null));
    return (
        <TextBlock {...props} section>
            {!isEmpty(moreInfoLink) ? (
                <div className={styles.link}>
                    <MoreInfo link={moreInfoLink} />
                </div>
            ) : null}
        </TextBlock>
    );
};

SectionTextBlock.propTypes = propTypes;
SectionTextBlock.defaultProps = defaultProps;

export default injectIntl(SectionTextBlock);



// WEBPACK FOOTER //
// ./js/components/blocks/SectionText.jsx